import { render, staticRenderFns } from "./SocialRewards.vue?vue&type=template&id=b2b8a992&"
import script from "./SocialRewards.vue?vue&type=script&lang=ts&"
export * from "./SocialRewards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports